<template>
  <div class="feedback-card col-12">
    <div class="card card-default mb-4">
      <div class="card-body">
        <span class="text-muted small"><i class="far fa-clock fa-fw"></i> {{ feedbackItem.createdAt | date_time_format }}</span><br/>

        <div class="row">
          <div class="col-6">
            <div class="row">
              <div class="col-12">
                <strong>Author: </strong>
                {{ feedbackItem.Author.fullName }}
              </div> 
            </div> 
            <div class="row">
              <div class="col-12">
              <strong>Quote Requested By: </strong>
                {{ requestedBy }}
              </div> 
            </div>
            <div class="row">
              <div class="col-12">
                <strong>Quote Id: </strong>
                <router-link
                  :to="{ path: '/quotes/' + feedbackItem.Quote.uuid}">
                  {{ feedbackItem.Quote.reference }}
                </router-link>
              </div> 
            </div> 
            <div class="row">
              <div class="col-12">
              <strong>Address: </strong>
                {{ feedbackItem.Quote.propertyAddress }}
              </div> 
            </div>
            <div class="row">
              <div class="col-12">
                <strong>Reasons:</strong>
                <ul>
                  <template v-for="(object, i) in feedbackItem.QuoteRejectReasonTypes">
                    <li v-if="object.type !== 'other'" :key="i">
                      {{ object.name }}
                    </li>
                  </template> 
                </ul>
              </div> 
            </div>
          </div> 
          <div class="col-6">
            <strong>Comments</strong> <br/>
            {{ feedbackItem.comment }}
          </div> 
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FeedbackCard',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    computed: {
      article () {
        if (['a', 'e', 'i', 'o', 'u'].includes(this.feedItem.reportType.toLowerCase().charAt(0))) {
          return 'an'
        }
        return 'a'
      },
      feedbackItem () {
        return {
          ...this.object
        }
      },
      requestedBy () {
        return this.feedbackItem.Quote.ocName ? '(' + this.feedbackItem.Quote.ocName + ') ' + this.feedbackItem.Quote.ocManagerName : this.feedbackItem.Quote.ocManagerName
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/FeedbackCard.vue